import * as React from 'react';

import styled from 'styled-components';

import { Option } from '@webapp/types/common/option';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import { rgba } from 'polished';

interface DatepickerFiltersProps {
  className?: string;
  active?: number;
  filters: Option<number>[];
  hasChanges?: boolean;
  onChange: (value: number) => void;
}

export const DatepickerFilters: React.FC<DatepickerFiltersProps> = (props) => {
  return (
    <Flex
      className={`${props.className} ${props.hasChanges ? 'has-changes' : ''}`}
      justifyContent="flex-start"
      alignItems="center"
    >
      {props.filters.map((filter) => (
        <Typography
          className={`filter-item ${
            props.active === filter.value ? 'active' : ''
          }`}
          weight="700"
          key={`filter-item-${filter.value}`}
          onClick={(ev) => {
            ev.stopPropagation();
            props.onChange(filter.value);
          }}
        >
          {filter.label}
        </Typography>
      ))}
    </Flex>
  );
};

export default styled(DatepickerFilters)`
  flex-flow: row wrap;
  justify-content: center;

  .filter-item {
    padding: 10px 20px;
    background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 18px;
    cursor: pointer;
    user-select: none;
    transition: background-color
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      background-color: ${({ theme }) => rgba(theme.colors.primary, 0.15)};
    }

    &.active {
      background-color: ${({ theme }) => theme.colors.accent};
      color: ${({ theme }) => theme.colors.white};
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &.has-changes {
    .filter-item {
      background-color: ${({ theme }) =>
        rgba(theme.colors.differentBackground, 0.05)};
      color: ${({ theme }) => theme.colors.differentBackground};

      &:hover {
        background-color: ${({ theme }) =>
          rgba(theme.colors.differentBackground, 0.15)};
      }
    }
  }
`;
